import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IInquiryCndsState, IPjt0103MState, IPjtCdItemState, IPjtMemberItemState, IProjectItemState, IComCdItemState, IUserItemState } from '../../models/pjt/pjt0103m_model';
  
const initialState: IPjt0103MState = {
    pjtCdList : [],     // 프로젝트코드목록
    pjtMmbrList : [],   // 프로젝트맴버목록 
    pjtItems : {},      // 프로젝트
    cmbList029: [],     // 소속코드
    userList: [],       // 사용자목록

    inquiryCnds: {},    // 조회조건
    pageSize : 20,      // 페이징사이즈
    current : 1,        // 현재페이지
}

export const pjt0103m_Slice = createSlice({
    name: "pjt0103m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState,
                                  pjtCdList : state.pjtCdList,
                                  cmbList029 : state.cmbList029});
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setPjtCdList: (state, action:PayloadAction<IPjtCdItemState[]>) => {
            state.pjtCdList = action.payload;
        },
        setCmbList029: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList029 = action.payload;
        },
        setPjtItems: (state, action:PayloadAction<IProjectItemState>) => {
            state.pjtItems = action.payload;
        },
        setPjtMmbrList: (state, action:PayloadAction<IPjtMemberItemState[]>) => {
            state.pjtMmbrList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default pjt0103m_Slice.reducer;
export const Pjt0103mAction  = pjt0103m_Slice.actions;
export const Pjt0103mReducer = pjt0103m_Slice.reducer;